/* =====================================================================
   SU DIWALI (Spice Up Foods, Diwali 2026)
   1. Gold rain fireworks (locked look): one show every 2.5 to 3.5 s at
      random, rocket rising, burst spot random across 6 zones and never the
      same zone as either of the last two bursts. Home and collection pages,
      and they keep going over the cart drawer when it is open.
   2. Diwali night, on every page: string lights and a pull cord hang from
      the header and stay on screen while scrolling (when the header slides
      away they sit at the top of the screen). Pulling the cord flickers the
      light off, the string lights and diyas catch one by one, three fireworks
      (colour, gold, colour; two on a budget phone), then fireflies that stay for
      as long as it is night. Pull again for the lights. Every pull switches
      at once, however fast; only the fireworks it sets off are limited.
   3. Cart: decorations on top of the SU cart drawer (marigold toran by day,
      string lights by night, a diya that lights when the cart has items,
      a small marigold garland along the top of the VIEW CART bar, a spark
      that flies into the cart on add, gold sparkle instead of confetti at
      free shipping). The drawer's own files are never edited:
      this only wraps its render, open, close and burst methods.
   4. Night readability guard: fixes any spot where text would vanish at
      night (light text on a white band or card, dark text on the dark page).
   5. Tracking: every pull of the cord is counted (Clarity, GA4, Meta, the
      dataLayer, Shopify customer events), and an order from someone who
      pulled it carries the cart attribute "Diwali night: pulled".
   Built for budget phones: work is sized to the phone (tier), every effect
   has a hard cap and a rate limit so tapping or pulling fast never piles up
   work (the cord still answers every pull), heavy checks run only in idle
   time, off-screen flames pause, and everything stops while the tab is in
   the background.
   Switched on and off by the SU Diwali section (Customize), India time.
   ===================================================================== */
(function () {
'use strict';
var cfgEl = document.querySelector('[data-su-dw-config]');
if (!cfgEl) return;
var CFG;
try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
var html = document.documentElement;
function store(kind, k, v) { try { var s = window[kind]; if (v === undefined) return s.getItem(k); if (v === null) s.removeItem(k); else s.setItem(k, v); } catch (e) { return null; } }
function ss(k, v) { return store('sessionStorage', k, v); }
function ls(k, v) { return store('localStorage', k, v); }

/* ---------- on only inside the Start / Stop window (India time), or when Live now is ticked ---------- */
var IST = 330 * 60000;
function parseIST(s) {
  var m = String(s || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
  if (!m) return NaN;
  return Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0)) - IST;
}
var START = parseIST(CFG.start), END = parseIST(CFG.end);
function live() {
  if (CFG.force) return true;
  if (!CFG.auto) return false;
  if (isNaN(START) || isNaN(END)) { if (window.console) console.warn('SU Diwali: check the Start and Stop dates in Customize (format 2026-10-20 00:00)'); return false; }
  var n = Date.now();
  return n >= START && n < END;
}
if (!live()) { ls('su_dw_until', null); html.classList.remove('night'); return; }
/* the head snippet reads this to switch night on before the page paints (no white flash) */
ls('su_dw_until', String(CFG.force ? Date.now() + 864e5 : END));

var $ = function (s, r) { return (r || document).querySelector(s); };
var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
var RM = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
var TPL = html.getAttribute('data-template') || '';
var BROWSE = /^(index|collection|list-collections|search)$/.test(TPL);   /* where the fireworks run by themselves */
html.classList.add('sud-dw');
if (ls('su_night') === '1') html.classList.add('night');
function isNight() { return html.classList.contains('night'); }

var FLAME = '<span class="sud-fw"><svg><use href="#sud-flame"/></svg></span>';
function mkFlame(cls) { var i = document.createElement('i'); i.className = 'sud-fl' + (cls ? ' ' + cls : ''); i.setAttribute('aria-hidden', 'true'); i.innerHTML = FLAME; return i; }
var POT_DARK = '<svg class="sud-pot"><use href="#sud-potdark"/></svg>';

/* shapes used by every flame and diya (drawn once, reused) */
var defs = document.createElement('div');
defs.className = 'sud-defs'; defs.setAttribute('aria-hidden', 'true');
defs.innerHTML = '<svg width="0" height="0" focusable="false">' +
  '<symbol id="sud-flame" viewBox="-30 -100 60 100"><path d="M0 0C-27-4-25-52 0-100C25-52 27-4 0 0Z" fill="#E8590C"/><path d="M0-5C-17-8-15-40 0-72C15-40 17-8 0-5Z" fill="#F2B705"/><path d="M0-9C-8-11-8-27 0-42C8-27 8-11 0-9Z" fill="#FFF3CF"/></symbol>' +
  '<symbol id="sud-pot" viewBox="0 0 60 36"><path d="M6 13C7 26 18 31 30 31C42 31 53 26 54 13" fill="#fff" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/><ellipse cx="30" cy="13" rx="24" ry="5" fill="#fff" stroke="currentColor" stroke-width="1.9"/><ellipse cx="30" cy="13" rx="18" ry="2.8" fill="none" stroke="#C79A1C" stroke-width="1"/><path d="M25 17.6Q30 21.5 35 17.6" fill="#fff" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M22 31L20.5 34H39.5L38 31" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="14" cy="23" r="1.3" fill="#C79A1C"/><circle cx="22" cy="26.6" r="1.3" fill="#C79A1C"/><circle cx="38" cy="26.6" r="1.3" fill="#C79A1C"/><circle cx="46" cy="23" r="1.3" fill="#C79A1C"/><path d="M30 18.5L30.6 13.6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></symbol>' +
  '<symbol id="sud-potdark" viewBox="0 0 60 36"><path d="M6 13C7 26 18 31 30 31C42 31 53 26 54 13" fill="none" stroke="#FBF6EA" stroke-width="2.4" stroke-linecap="round"/><ellipse cx="30" cy="13" rx="24" ry="5" fill="none" stroke="#FBF6EA" stroke-width="2.4"/><path d="M25 17.6Q30 21.5 35 17.6" fill="none" stroke="#FBF6EA" stroke-width="2.1" stroke-linecap="round"/><path d="M22 31L20.5 34H39.5L38 31" fill="none" stroke="#FBF6EA" stroke-width="2.1" stroke-linejoin="round"/><path d="M30 18.5L30.6 13.6" stroke="#FBF6EA" stroke-width="2.1" stroke-linecap="round"/></symbol>' +
  '</svg>';
document.body.appendChild(defs);

/* =====================================================================
   1. ENGINE (crisp canvas: hard-edged streaks and 4-point glints, no blur)
   ===================================================================== */
var GOLD = ['#FFD27A', '#F2B705', '#FFC93C', '#E0A100'];
var cv = document.createElement('canvas');
cv.className = 'sud-fx'; cv.setAttribute('aria-hidden', 'true');
document.body.appendChild(cv);
var ctx = cv.getContext('2d');
/* phone tier: 0 = budget (2 GB or 2 cores), 1 = mid, 2 = strong. Browsers that do not report memory
   (iPhone Safari, Firefox) count as mid; the frame watchdog then adjusts on the real phone. */
var MEM = navigator.deviceMemory, CORES = navigator.hardwareConcurrency || 4;
var TIER = MEM ? (MEM <= 2 || CORES <= 2 ? 0 : MEM <= 4 || CORES <= 4 ? 1 : 2) : 1;
/* a phone the watchdog found struggling earlier in this visit starts at the lighter resolution it settled on */
var DPR = Math.min([1.5, 2, 3][TIER], window.devicePixelRatio || 1, +ss('sud_dpr') || 9), W = 0, H = 0, G = .085;
var CAP0 = [150, 220, 340][TIER], Q0 = [.6, .8, 1][TIER], CAP = CAP0, Q = Q0, MAX_SHELLS = TIER ? 3 : 2, GAP_MS = 700;
var reduce = RM;   /* only the phone's "reduce motion" setting stops the fireworks */
ss('su_fw_off', null);   /* an older build could switch fireworks off for the visit; clear that */
var BX = [0, 0, 0, 0], PB = null, SR = [], PSR = [];
function grow(x, y) { if (x < BX[0]) BX[0] = x; if (y < BX[1]) BX[1] = y; if (x > BX[2]) BX[2] = x; if (y > BX[3]) BX[3] = y; }
/* small drifting things (fireflies) are cleared one by one, not as one huge box */
function sgrow(x0, y0, x1, y1) { SR.push(Math.floor(x0) - 2, Math.floor(y0) - 2, Math.ceil(x1 - x0) + 4, Math.ceil(y1 - y0) + 4); }
function size() { W = innerWidth; H = innerHeight; cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR); ctx.setTransform(DPR, 0, 0, DPR, 0, 0); PB = null; PSR.length = 0; }
var parts = [], rockets = [], flashes = [], flights = [], smokes = [], flies = [];
var shells = 0, awake = false, last = 0, lastShow = 0, frames = [], frameNo = 0, fliesFrom = Infinity;
var NIGHT_FLIES = TIER === 0 ? 4 : innerWidth < 750 ? 8 : 12;
/* spam guards: however fast anyone taps, pulls or adds, the amount on screen stays capped */
var LIM = {
  stars: 40, starsAt: 0,          /* crackle sparkles: a bucket of 40 that refills at 40 a second */
  sparkAt: -1e9,                  /* add-to-cart spark: one at a time, at most one every 0.4 s */
  rewardAt: -1e9,                 /* free shipping sparkle: at most one every 2 s */
  barrageAt: -1e9                 /* lights-off barrage: at most one every 10 s (the cord itself always answers) */
};
function takeStars(n) {
  var now = performance.now();
  LIM.stars = Math.min(40, LIM.stars + (now - LIM.starsAt) * .04); LIM.starsAt = now;
  n = Math.min(n, Math.floor(LIM.stars)); LIM.stars -= n; return n;
}
function rand(a, b) { return a + Math.random() * (b - a); }
function pick(a) { return a[(Math.random() * a.length) | 0]; }
function spark(o) {
  if (parts.length >= CAP) return;
  parts.push({ x: o.x, y: o.y, vx: o.vx, vy: o.vy, fr: o.fr, gv: o.gv, life: 1, dec: o.dec, c: o.c, r: o.r || 1.5,
    h: [], hl: o.hl || 4, tw: o.tw || 0, glint: Math.random() < (o.glint || 0), gs: o.gs || 4.5, crackle: o.crackle || 0, crackAt: o.crackAt || .5, still: o.still || 0 });
}
function star(x, y, c, gs, dec, vx, vy) { spark({ x: x, y: y, vx: vx || 0, vy: vy === undefined ? .15 : vy, fr: .9, gv: .004, dec: dec || .09, c: c || pick(GOLD), r: .9, still: 1, gs: gs || 4.5 }); }
function flash(x, y, c, k) { if (flashes.length >= 6) return; var rays = [], i; k = k || 1; for (i = 0; i < 10; i++) rays.push([(i / 10) * 6.283 + rand(-.12, .12), rand(10, 20) * k]); flashes.push({ x: x, y: y, c: c, rays: rays, life: 1 }); }
function crackleAt(x, y, n, spread) { if (RM) return; n = takeStars(n); for (var i = 0; i < n; i++) { var a = rand(0, 6.283), d = rand(2, spread || 12); star(x + Math.cos(a) * d, y + Math.sin(a) * d, null, rand(2.6, 3.8), rand(.05, .08), Math.cos(a) * .4, Math.sin(a) * .4 - .2); } wake(); }
/* two shells of the lights-off barrage burst in colour (rani pink, green, blue / violet, red, turquoise); everything else stays gold */
var COLOUR = [['#FF4FA8', '#2EE68A', '#46AEFF'], ['#B77BFF', '#FF5A4E', '#33E3D4']];
/* gold rain: a wide glitter burst that slows, hangs and drifts down, crackling as it falls */
function burst(x, y, k, pal) {
  var c1 = pick(GOLD), c2 = pick(GOLD.filter(function (c) { return c !== c1; })), cs = pal || [c2, c1], i, n = Math.round(54 * Q * (k || 1)), a, v;
  n = Math.max(0, Math.min(n, CAP - parts.length - 8));   /* a full sky gets a thinner ring, never half a ring */
  shells++; setTimeout(function () { shells = Math.max(0, shells - 1); }, 3200);
  flash(x, y, cs[0]);
  for (i = 0; i < n; i++) { a = (i / n) * 6.283 + rand(-.06, .06); v = rand(2.4, 4.4);
    spark({ x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, fr: .965, gv: .07, dec: rand(.0045, .006), c: cs[i % cs.length], hl: 5, crackle: .05, crackAt: .85, tw: 1, glint: .15 }); }
  wake();
}
function rocket(x0, tx, ty, k, pal) { var vy = -Math.sqrt(2 * G * Math.max(80, H + 6 - ty)), t = Math.abs(vy) / G; rockets.push({ x: x0, y: H + 6, vx: (tx - x0) / t, vy: vy, ty: ty, h: [], k: k || 1, pal: pal }); }
/* 6 zones (left, centre, right x higher, lower, between 8% and 42% of the screen); never the zone of either of the last two bursts */
var zA = -1, zB = -1;
function spot() {
  var z, col, row, cw = W * .76 / 3, top = H * .08, rh = (H * .42 - top) / 2;
  do { z = (Math.random() * 6) | 0; } while (z === zA || z === zB);
  zB = zA; zA = z; col = z % 3; row = (z / 3) | 0;
  return [W * .12 + (col + rand(.1, .9)) * cw, top + (row + rand(.1, .9)) * rh];
}
function launchAt(p, k, pal) { rocket(Math.min(W * .94, Math.max(W * .06, p[0] + rand(-70, 70))), p[0], p[1], k, pal); wake(); }
function show() {
  if (reduce || document.hidden || busy()) return false;
  var now = performance.now();
  if (now - lastShow < GAP_MS || shells + rockets.length >= MAX_SHELLS || parts.length > CAP * .7) return false;
  lastShow = now; launchAt(spot());
  return true;
}
/* a short barrage when the lights go off (on any page), at most once every 10 s: 3 fireworks, 2 on a
   budget phone. Never more than that in the sky at once, counting a show that is already up: a rocket
   waits for room (up to 6 s) instead of adding to it. The 1st and 3rd burst in colour, the 2nd in gold,
   so the colour always shows first.
   If the lights go back on, the rockets not yet launched stay put. */
function barrage(n, gap, s) {
  if (reduce) return false;
  var now = performance.now(); if (now - LIM.barrageAt < 10000) return false;
  n = Math.min(n, MAX_SHELLS);
  LIM.barrageAt = now; lastShow = now + n * gap;
  for (var i = 0; i < n; i++) (function (i) {
    var waited = 0;
    function go() {
      if (s !== undefined && s !== nightSeq) return;
      if (shells + rockets.length >= MAX_SHELLS || parts.length > CAP * .7) { if ((waited += 200) <= 6000) setTimeout(go, 200); return; }
      launchAt(spot(), .72, i === 1 ? null : COLOUR[i >> 1]);
    }
    setTimeout(go, i * gap);
  })(i);
  return true;
}
function fly(from, to, done) {
  if (RM) { done(); return; }
  var mx = (from[0] + to[0]) / 2, my = Math.min(from[1], to[1]) - Math.abs(from[0] - to[0]) * .35 - 40;
  flights.push({ x0: from[0], y0: from[1], cx: mx, cy: my, x1: to[0], y1: to[1], t0: performance.now(), dur: 620, h: [], done: done });
  wake();
}
/* fireflies: crisp points that drift and blink for as long as it is night */
function fireflies(delay) { if (RM) return; fliesFrom = performance.now() + delay; wake(); }
function endFireflies() { fliesFrom = Infinity; var now = performance.now(); flies.forEach(function (f) { f.end = Math.min(f.end, now + 500); }); }
function nightFlies() { return !RM && isNight() && fliesFrom !== Infinity; }
function wake() { if (!awake) { awake = true; last = 0; requestAnimationFrame(tick); } }
var quietUntil = 0;
function quiet(ms) { quietUntil = Math.max(quietUntil, performance.now() + (ms || 450)); frames = []; }
/* frame-time watchdog: on a phone that is struggling it first lowers the canvas resolution (one step at
   a time, down to 1.5, kept for the rest of the visit so the next page starts light), then thins the
   sparks, and gives the sparks back once things are smooth again. It never switches the fireworks off.
   "Struggling" means more than 5 of 40 frames, while fireworks are up, take over 1.5 times that phone's
   own normal frame. So a phone in battery saver (30 frames a second, steady) is fine, a phone dropping
   one frame in eight is caught, and one long pause (a tab switch, a page load) is ignored. */
function watchdog(dt) {
  if (performance.now() < quietUntil) return;
  if (!rockets.length && parts.length < 40) { frames = []; return; }   /* only judge frames while a firework is in the sky */
  if (dt > 250) return;
  frames.push(dt);
  if (frames.length < 40) return;
  var base = frames.slice().sort(function (a, b) { return a - b; })[8], slow = 0, i;
  for (i = 0; i < frames.length; i++) if (frames[i] > base * 1.5) slow++;
  frames = [];
  if (slow > 5) {
    if (DPR > 1.5) { DPR = DPR > 2 ? 2 : 1.5; ss('sud_dpr', String(DPR)); size(); }
    else { Q = Math.max(.45, Q * .85); CAP = Math.max(140, Math.round(CAP * .88)); }
  } else if (slow < 2 && (Q < Q0 || CAP < CAP0)) { Q = Math.min(Q0, Q + .05); CAP = Math.min(CAP0, CAP + 12); }
}
var SB = {}, FB = {}, TB = {}, SK = [], FK = [], TK = [];
function lvl(a) { return Math.max(1, Math.ceil(a * 6)) / 6; }
function sb(c, a, w) { var k = c + a + '|' + w, b = SB[k]; if (!b) { b = SB[k] = { c: c, a: a, w: w, d: [] }; SK.push(k); } return b.d; }
function fb(c, a) { var k = c + a, b = FB[k]; if (!b) { b = FB[k] = { c: c, a: a, d: [] }; FK.push(k); } return b.d; }
function tb(c, a) { var k = c + a, b = TB[k]; if (!b) { b = TB[k] = { c: c, a: a, d: [] }; TK.push(k); } return b.d; }
function seg(d, x1, y1, x2, y2) { d.push(x1, y1, x2, y2); }
function glintAt(x, y, c, a, s) { tb(c, lvl(a)).push(x, y, s); }
function dot(x, y, r, c, a) { fb(c, lvl(a)).push(x, y, r); }
function trail(p, c, a) {
  var h = p.h, n = h.length; if (n < 4) return;
  var mid = Math.max(2, ((n / 6) | 0) * 2), i, d1 = sb(c, lvl(a * .35), .85), d2 = sb(c, lvl(a), 1.3);
  for (i = 0; i < mid; i += 2) seg(d1, h[i], h[i + 1], h[i + 2], h[i + 3]);
  for (i = mid; i < n - 2; i += 2) seg(d2, h[i], h[i + 1], h[i + 2], h[i + 3]);
  seg(d2, h[n - 2], h[n - 1], p.x, p.y);
}
function flush() {
  var i, j, b, d, x, y, z, q;
  ctx.lineCap = 'butt';
  for (i = 0; i < SK.length; i++) { b = SB[SK[i]]; d = b.d; if (!d.length) continue; ctx.globalAlpha = b.a; ctx.strokeStyle = b.c; ctx.lineWidth = b.w; ctx.beginPath(); for (j = 0; j < d.length; j += 4) { ctx.moveTo(d[j], d[j + 1]); ctx.lineTo(d[j + 2], d[j + 3]); } ctx.stroke(); d.length = 0; }
  for (i = 0; i < TK.length; i++) { b = TB[TK[i]]; d = b.d; if (!d.length) continue; ctx.globalAlpha = b.a; ctx.fillStyle = b.c; ctx.beginPath();
    for (j = 0; j < d.length; j += 3) { x = d[j]; y = d[j + 1]; z = d[j + 2]; q = z * .16; ctx.moveTo(x, y - z); ctx.lineTo(x + q, y - q); ctx.lineTo(x + z, y); ctx.lineTo(x + q, y + q); ctx.lineTo(x, y + z); ctx.lineTo(x - q, y + q); ctx.lineTo(x - z, y); ctx.lineTo(x - q, y - q); ctx.closePath(); }
    ctx.fill(); d.length = 0; }
  for (i = 0; i < FK.length; i++) { b = FB[FK[i]]; d = b.d; if (!d.length) continue; ctx.globalAlpha = b.a; ctx.fillStyle = b.c; ctx.beginPath(); for (j = 0; j < d.length; j += 3) { ctx.moveTo(d[j] + d[j + 2], d[j + 1]); ctx.arc(d[j], d[j + 1], d[j + 2], 0, 6.283); } ctx.fill(); d.length = 0; }
  ctx.globalAlpha = 1;
}
function tick(t) {
  if (last) watchdog(t - last);
  last = t; frameNo++;
  if (PB) ctx.clearRect(PB[0], PB[1], PB[2] - PB[0], PB[3] - PB[1]);
  for (var ci = 0; ci < PSR.length; ci += 4) ctx.clearRect(PSR[ci], PSR[ci + 1], PSR[ci + 2], PSR[ci + 3]);
  BX[0] = BX[1] = 1e9; BX[2] = BX[3] = -1e9;
  var now = performance.now(), f, r, i;
  /* fireflies */
  var wantFlies = nightFlies() && now >= fliesFrom ? NIGHT_FLIES : 0;
  if (flies.length < wantFlies && frameNo % 7 === 0) flies.push({ x: rand(W * .05, W * .95), y: rand(H * .25, H * .95), vx: rand(-.2, .2), vy: rand(-.2, .1), ph: rand(0, 6.28), sp: rand(.05, .11), t0: now, end: now + rand(6000, 11000) });
  for (i = flies.length - 1; i >= 0; i--) {
    var Fy = flies[i];
    if (now >= Fy.end) { flies.splice(i, 1); continue; }
    Fy.vx = Math.max(-.32, Math.min(.32, Fy.vx + rand(-.025, .025))); Fy.vy = Math.max(-.32, Math.min(.28, Fy.vy + rand(-.025, .022)));
    Fy.x += Fy.vx; Fy.y += Fy.vy; Fy.ph += Fy.sp;
    if (Fy.x < 4 || Fy.x > W - 4) Fy.vx *= -1;
    if (Fy.y < 4 || Fy.y > H - 4) Fy.vy *= -1;
    var fade = Math.min(1, (now - Fy.t0) / 700, (Fy.end - now) / 900), bl = Math.sin(Fy.ph) > -.15 ? 1 : .25, fa = fade * bl;
    if (fa > .05) { dot(Fy.x, Fy.y, 3.4, '#FFE38A', fa * .2); dot(Fy.x, Fy.y, 1.5, '#FFF3C4', fa); sgrow(Fy.x - 5, Fy.y - 5, Fy.x + 5, Fy.y + 5); }
  }
  for (f = flashes.length - 1; f >= 0; f--) {
    var F = flashes[f], gr = 1 - F.life, fd = sb(F.c, lvl(F.life), 1); grow(F.x - 34, F.y - 34); grow(F.x + 34, F.y + 34);
    for (var q = 0; q < F.rays.length; q++) { var ra = F.rays[q], r0 = 3 + ra[1] * gr * .6, r1 = 3 + ra[1] * (.4 + gr); seg(fd, F.x + Math.cos(ra[0]) * r0, F.y + Math.sin(ra[0]) * r0, F.x + Math.cos(ra[0]) * r1, F.y + Math.sin(ra[0]) * r1); }
    F.life -= .16; if (F.life <= 0) flashes.splice(f, 1);
  }
  for (r = rockets.length - 1; r >= 0; r--) {
    var k = rockets[r]; k.h.push(k.x, k.y); if (k.h.length > 14) k.h.splice(0, 2);
    k.x += k.vx; k.y += k.vy; k.vy += G;
    trail(k, GOLD[1], .9); dot(k.x, k.y, 1.4, GOLD[3], 1); grow(k.x, k.y); grow(k.h[0], k.h[1]);
    if (Math.random() < .4) spark({ x: k.x, y: k.y + 2, vx: rand(-.35, .35), vy: rand(.4, 1), fr: .94, gv: .02, dec: .07, c: GOLD[1], r: .8, hl: 2 });
    if (k.y <= k.ty || k.vy >= -.4) { rockets.splice(r, 1); burst(k.x, k.y, k.k, k.pal); }
  }
  for (var fi = flights.length - 1; fi >= 0; fi--) {
    var L = flights[fi], u = Math.min(1, (now - L.t0) / L.dur), e = u < .5 ? 2 * u * u : 1 - Math.pow(-2 * u + 2, 2) / 2;
    var ix = (1 - e) * (1 - e) * L.x0 + 2 * (1 - e) * e * L.cx + e * e * L.x1, iy = (1 - e) * (1 - e) * L.y0 + 2 * (1 - e) * e * L.cy + e * e * L.y1;
    L.h.push(ix, iy); if (L.h.length > 12) L.h.splice(0, 2);
    trail({ h: L.h, x: ix, y: iy }, GOLD[3], 1); glintAt(ix, iy, GOLD[1], 1, 5.5); grow(ix, iy); grow(L.h[0], L.h[1]);
    if (Math.random() < .8) star(ix + rand(-3, 3), iy + rand(-3, 3), null, rand(2.4, 3.4), rand(.06, .1), rand(-.3, .3), rand(.1, .5));
    if (u >= 1) { flights.splice(fi, 1); crackleAt(L.x1, L.y1, 10, 14); flash(L.x1, L.y1, GOLD[1], .55); try { L.done(); } catch (err) {} }
  }
  for (var si = smokes.length - 1; si >= 0; si--) {
    var S = smokes[si], a2 = (now - S.t0) / 1100;
    if (a2 >= 1) { smokes.splice(si, 1); continue; }
    var sd = sb('#8C8070', lvl((1 - a2) * .55), 1), py = S.y, px = S.x;
    for (var sj = 1; sj <= 8; sj++) { var yy = S.y - sj * 4.5 * (.6 + a2), xx = S.x + Math.sin(sj * .9 + a2 * 6) * (1.5 + sj * .5); seg(sd, px, py, xx, yy); px = xx; py = yy; }
    grow(S.x - 10, S.y - 60); grow(S.x + 10, S.y + 2);
  }
  for (i = parts.length - 1; i >= 0; i--) {
    var p = parts[i];
    if (!p.still) { p.h.push(p.x, p.y); if (p.h.length > p.hl * 2) p.h.splice(0, 2); }
    p.vx *= p.fr; p.vy = p.vy * p.fr + p.gv; p.x += p.vx; p.y += p.vy; p.life -= p.dec;
    /* crackle leaves the last fifth of the spark budget free, so the next shell always gets its full ring */
    if (p.crackle && p.life < p.crackAt && parts.length < CAP * .8 && Math.random() < p.crackle) star(p.x + rand(-6, 6), p.y + rand(-6, 6), p.c);
    if (p.life <= 0 || p.y > H + 10) { parts.splice(i, 1); continue; }
    var al = Math.min(1, p.life * 1.6);
    if (p.tw && p.life < .5 && Math.random() < .35) continue;
    if (p.still && (((p.life * 100) | 0) % 4 < 2)) continue;
    grow(p.x, p.y); if (p.h.length) grow(p.h[0], p.h[1]);
    if (!p.still) trail(p, p.c, al);
    if (p.still || (p.glint && Math.random() < .4)) glintAt(p.x, p.y, p.c, al, (p.still ? p.gs : 3.5) + 3 * p.life);
    else dot(p.x, p.y, p.r * (.65 + .35 * p.life), p.c, al);
  }
  flush();
  var tmp = PSR; PSR = SR; SR = tmp; SR.length = 0;   /* this frame's firefly boxes are next frame's clears */
  PB = BX[2] < BX[0] ? null : [Math.max(0, BX[0] - 10), Math.max(0, BX[1] - 10), Math.min(W, BX[2] + 10), Math.min(H, BX[3] + 10)];
  if (parts.length || rockets.length || flashes.length || flights.length || smokes.length || flies.length || nightFlies()) requestAnimationFrame(tick);
  else { ctx.clearRect(0, 0, W, H); PB = null; PSR.length = 0; awake = false; }
}
/* =====================================================================
   STRING LIGHTS (under the header, and in the drawer at night)
   ===================================================================== */
var lightSets = [];
function buildLights(host, extra) {
  var el = document.createElement('div');
  el.className = 'sud-lights' + (extra ? ' ' + extra : ''); el.setAttribute('aria-hidden', 'true');
  host.appendChild(el);
  var set = { el: el, host: host, w: 0 };
  lightSets.push(set); layoutLights(set);
  return set;
}
function layoutLights(set) {
  var w = set.el.clientWidth || set.host.clientWidth; if (!w || w === set.w) return; set.w = w;
  /* bigger bulbs and longer loops on bigger screens (1.3x from 750 px, 1.6x from 1200 px); phones stay as they are */
  var z = w >= 1200 ? 1.6 : w >= 750 ? 1.3 : 1, hh = 22 * z;
  var n = Math.max(3, Math.min(24, Math.round(w / (50 * z)))), sw = w / n, d = 'M0 1', bulbs = '', k = 0;
  for (var i = 0; i < n; i++) {
    var x0 = i * sw; d += 'Q' + (x0 + sw / 2).toFixed(1) + ' ' + (12 * z - z + 1).toFixed(1) + ' ' + (x0 + sw).toFixed(1) + ' 1';
    for (var j = 0; j < 2; j++) {
      var t = j ? .73 : .27, x = x0 + sw * t, y = 1 + 22 * z * t * (1 - t);
      bulbs += '<span class="sud-bulb c' + (k % 3 + 1) + '" style="left:' + x.toFixed(1) + 'px;top:' + (y - .6).toFixed(1) + 'px;--d:' + (.3 + k * .045 + Math.random() * .12).toFixed(2) + 's"><i></i><b></b></span>';
      k++;
    }
  }
  set.el.style.height = hh + 'px'; set.el.style.setProperty('--z', z);
  set.el.innerHTML = '<svg viewBox="0 0 ' + w + ' ' + hh + '" preserveAspectRatio="none" focusable="false" style="height:' + hh + 'px"><path d="' + d + '" fill="none" stroke="#6B5B40" stroke-width="' + (z > 1 ? 1.3 : 1) + '"/></svg>' + bulbs;
}
var twTimer = null;
function twinkle() {   /* now and then one bulb flutters, like a real string */
  if (twTimer || RM) return;
  twTimer = setInterval(function () {
    if (!isNight() || document.hidden) return;
    var bs = $$('.sud-lights .sud-bulb').filter(function (b) { return b.offsetParent; }); if (!bs.length) return;
    var lit = pick(bs).querySelector('b');
    if (lit && lit.animate) lit.animate([{ opacity: 1 }, { opacity: .25, offset: .3 }, { opacity: .9, offset: .55 }, { opacity: .45, offset: .7 }, { opacity: 1 }], { duration: 420 });
  }, 1500);
}

/* =====================================================================
   2. CART on the SU cart drawer
   ===================================================================== */
var inst = null, root = null, headFl = null, barGarland = null, cartCount = 0, drawerLights = null;
function isOpen() { return !!(root && root.classList.contains('is-open')); }
function paidCount(cart) { var n = 0; ((cart && cart.items) || []).forEach(function (i) { if (!(i.properties && i.properties._su_gift)) n += Number(i.quantity || 0); }); return n; }
function center(el) { var b = el.getBoundingClientRect(); return [b.left + b.width / 2, b.top + b.height / 2]; }
function flameTip(fl) { var b = fl.getBoundingClientRect(); return [b.left + b.width / 2, b.top + b.height - fl.offsetHeight * .55]; }
function visible(el) { if (!el || el.hidden) return false; var b = el.getBoundingClientRect(); return b.width > 0 && b.height > 0 && b.bottom > 0 && b.top < innerHeight && getComputedStyle(el).visibility !== 'hidden'; }
function setFlame(fl, on, settle, instant) {
  if (!fl || on === fl.classList.contains('on')) return;
  if (instant) { fl.style.transition = 'none'; setTimeout(function () { fl.style.transition = ''; }, 60); }
  else if (!on && smokes.length < 2 && visible(fl.parentNode)) { var t = flameTip(fl); smokes.push({ x: t[0], y: t[1] - 4, t0: performance.now() }); wake(); }
  fl.classList.toggle('on', on);
  fl.classList.remove('settle'); void fl.offsetWidth;
  if (on && settle && !RM) fl.classList.add('settle');
}
function flare(fl) { if (!fl) return; fl.classList.remove('flare'); void fl.offsetWidth; fl.classList.add('flare'); }
function decorate() {
  var head = $('.su-cart__head', root);
  if (head && !$('.sud-toran', head)) { var t = document.createElement('div'); t.className = 'sud-toran'; t.setAttribute('aria-hidden', 'true'); head.insertBefore(t, head.firstChild); }
  if (head && !drawerLights) drawerLights = buildLights(head, 'sud-dlights');
  var title = $('.su-cart__title', root);
  if (title && !$('.sud-diya', title)) {
    var d = document.createElement('span'); d.className = 'sud-diya'; d.setAttribute('aria-hidden', 'true');
    d.innerHTML = '<svg class="sud-pot sud-lt"><use href="#sud-pot"/></svg><svg class="sud-pot sud-dk"><use href="#sud-potdark"/></svg>';
    headFl = mkFlame(); d.appendChild(headFl); title.insertBefore(d, title.firstChild);
  }
  /* VIEW CART bar: a small marigold and mango-leaf garland hangs along its top edge */
  var bar = $('[data-su-bar]', root);
  if (bar && !$('.sud-bgarland', bar)) {
    barGarland = document.createElement('span'); barGarland.className = 'sud-bgarland'; barGarland.setAttribute('aria-hidden', 'true');
    var fill = $('[data-su-bar-fill]', bar); bar.insertBefore(barGarland, fill ? fill.nextSibling : bar.firstChild);
    /* drawn to the bar's exact width, so it always ends in whole swags tied at both ends */
    if (window.ResizeObserver) new ResizeObserver(function () { layoutGarland(); }).observe(barGarland);
    layoutGarland();
  }
}
var gW = 0;
function layoutGarland() {
  if (!barGarland) return;
  var w = Math.round(barGarland.clientWidth); if (!w || w === gW) return; gW = w;
  var n = Math.max(3, Math.round(w / 30)), sw = w / n, m = Math.max(5, Math.round(sw / 4.3)), d = '', beads = '', leaves = '', i, k;
  var C1 = ['#F7B51E', '#D98A0B'], C2 = ['#F0841A', '#C4560A'], C3 = ['#E8590C', '#B23F08'];
  for (i = 0; i < n; i++) {
    var x0 = i * sw, cx = x0 + sw / 2, x2 = x0 + sw;
    d += (i ? '' : 'M0 1.8') + 'Q' + cx.toFixed(1) + ' 9.6 ' + x2.toFixed(1) + ' 1.8';
    for (k = 0; k < m; k++) {
      var t = .14 + .72 * k / (m - 1), x = (1 - t) * (1 - t) * x0 + 2 * (1 - t) * t * cx + t * t * x2, y = (1 - t) * (1 - t) * 1.8 + 2 * (1 - t) * t * 9.6 + t * t * 1.8;
      var c = k === (m - 1) / 2 ? C3 : k % 2 ? C2 : C1;
      beads += '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(2) + '" r="2.05" fill="' + c[0] + '"/><circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(2) + '" r=".8" fill="' + c[1] + '"/>';
    }
  }
  for (i = 0; i <= n; i++) {   /* a mango leaf at every join; the two ends are tied with a bigger gold knot and a longer leaf */
    var lx = i * sw, end = i === 0 || i === n, len = end ? 10.6 : 9.2, a = (lx - 1.7).toFixed(1), b = (lx + 1.7).toFixed(1), xs = lx.toFixed(1), y1 = (len - 2.4).toFixed(1);
    leaves += '<path d="M' + xs + ' 2.4C' + b + ' 4.3 ' + b + ' ' + y1 + ' ' + xs + ' ' + len + 'C' + a + ' ' + y1 + ' ' + a + ' 4.3 ' + xs + ' 2.4Z" fill="#3E8F5A"/>' +
      '<circle cx="' + xs + '" cy="1.8" r="' + (end ? 1.7 : 1.15) + '" fill="#E3B53A"/>';
  }
  barGarland.innerHTML = '<svg viewBox="0 0 ' + w + ' 12" width="' + w + '" height="12" focusable="false"><path d="' + d + '" fill="none" stroke="#C79A1C" stroke-width=".7"/>' + leaves + beads + '</svg>';
}
function sway(el) { if (!el || RM) return; el.classList.remove('sway'); void el.offsetWidth; el.classList.add('sway'); }
function onCart(cart, initial) {
  var n = paidCount(cart); cartCount = n;
  if (!window.ResizeObserver) setTimeout(layoutGarland, 60);
  if (isOpen()) setFlame(headFl, n > 0, true);
  else if (initial) setFlame(headFl, n > 0, false, true);
}
function onOpen() {
  quiet();   /* the fireworks carry on over the open drawer */
  if (drawerLights) setTimeout(function () { layoutLights(drawerLights); }, 30);   /* rebuilt only if its width changed */
  if (cartCount > 0 && headFl && !headFl.classList.contains('on')) {
    setTimeout(function () { if (!isOpen() || !cartCount) return; setFlame(headFl, true, true); var t = flameTip(headFl); crackleAt(t[0], t[1], 7, 10); }, 280);
  } else if (cartCount === 0) setFlame(headFl, false);
}
/* the spark lands on the drawer's diya when the drawer is open, otherwise on the item count in the VIEW CART bar (and the garland sways) */
function sparkFrom(el) {
  if (!el || !el.isConnected) return;
  var now = performance.now();
  if (flights.length || now - LIM.sparkAt < 400) return;   /* tapping ADD again and again still adds; only one spark flies */
  LIM.sparkAt = now;
  if (isOpen()) { if (headFl) fly(center(el), flameTip(headFl), function () { flare(headFl); }); return; }
  var bar = $('[data-su-bar]', root);
  if (!visible(bar)) return;
  var spot = $('[data-su-bar-count]', bar) || bar;
  fly(center(el), center(spot), function () { sway(barGarland); });
}
function sparkleAtReward() {
  var dotEl = $('.su-cart__dot', root) || $('[data-su-msg]', root); if (!dotEl || RM) return;
  var now = performance.now(); if (now - LIM.rewardAt < 2000) return; LIM.rewardAt = now;
  var c = center(dotEl); crackleAt(c[0], c[1], 16, 22); flash(c[0], c[1], GOLD[1], .7);
}
function willOpenOnAdd() {
  if (!inst) return true;
  var barLive = !!($('[data-su-bar]', root) && inst.config && inst.config.bar && inst.config.bar.enabled);
  return !barLive || !inst.config.bar.openFirstAdd || !inst.seenDrawer();
}
/* the spark leaves the moment ADD is tapped (on the first add of a visit the drawer opens instead) */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-su-upsell-add], form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] [type="submit"]');
  if (!b || b.disabled || !inst) return;
  if (isOpen() || !willOpenOnAdd()) { try { sparkFrom(b); } catch (err) {} }
}, true);
function hook() {
  inst = window.SUCartDrawerInstance; root = inst.root || $('[data-su-cart]');
  if (!root) return;
  decorate();
  var oRender = inst.render, oOpen = inst.open, oClose = inst.close;
  inst.render = function (cart) { var r = oRender.apply(this, arguments); try { onCart(cart); } catch (e) {} return r; };
  inst.open = function () { var r = oOpen.apply(this, arguments); try { onOpen(); } catch (e) {} return r; };
  inst.close = function () { var r = oClose.apply(this, arguments); quiet(); return r; };
  inst.burst = function () { try { sparkleAtReward(); } catch (e) {} };
  if (inst.cart) onCart(inst.cart, true);
}
(function waitDrawer(tries) {
  if (window.SUCartDrawerInstance) { hook(); return; }
  if (tries > 150) return;
  setTimeout(function () { waitDrawer(tries + 1); }, 80);
})(0);

/* =====================================================================
   3. DIWALI NIGHT (every page)
   The string lights and cord live inside the header bar, just below it.
   When the theme slides the header up out of view on scroll, the bar's
   bottom edge sits at the top of the screen, so they stay in view there.
   ===================================================================== */
var hdr = $('m-header .m-header__wrapper') || $('.m-header__wrapper');
var cord = null, line = null, bead = null, hint = null, curtain = null;
var C = { lastPtr: 0, y: 0, x: 0, vy: 0, vx: 0, drag: false, sx: 0, sy: 0, t0: 0, moved: false, clicked: false, running: false, lastScroll: 0, pullUntil: 0 };
var REST = 44, TRIP = 24, nightBusy = false, nightSeq = 0, wantNight = isNight(), lastFlip = -1e9, fade = null;

/* diyas beside the section headings and in a row at the top of the footer; they only show at night */
function placeDiyas() {
  $$('.m-section__heading, [id^="ats-marquee-"] .ATS-heading > h2').forEach(function (h, i) {
    if ($('.sud-hdiya', h) || h.closest('.su-cart, .shopify-app-block, .ats-certification-section')) return;   /* not on light panels */
    var d = (.45 + i * .12).toFixed(2), both = getComputedStyle(h).textAlign === 'center';
    h.insertAdjacentHTML('afterbegin', '<span class="sud-hdiya" aria-hidden="true" style="--d:' + d + 's">' + POT_DARK + '<i class="sud-fl on live">' + FLAME + '</i></span>');
    if (both) h.insertAdjacentHTML('beforeend', '<span class="sud-hdiya" aria-hidden="true" style="--d:' + (+d + .06).toFixed(2) + 's">' + POT_DARK + '<i class="sud-fl on live">' + FLAME + '</i></span>');
  });
  var foot = $('m-footer.m-footer') || $('.m-footer');
  if (foot && !$('.sud-rowdiyas', foot)) {
    var row = document.createElement('div'); row.className = 'sud-rowdiyas'; row.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 7; i++) row.insertAdjacentHTML('beforeend', '<span style="--d:' + (.7 + i * .09).toFixed(2) + 's">' + POT_DARK + '<i class="sud-fl on live">' + FLAME + '</i></span>');
    foot.insertBefore(row, foot.firstChild);
  }
  $$('.sud-hdiya .sud-fl svg, .sud-rowdiyas .sud-fl svg').forEach(function (s, i) { s.style.animationDuration = (1.1 + (i % 5) * .13) + 's'; s.style.animationDelay = (-i * .23) + 's'; });
  /* flames that are off screen stop flickering, so a long page costs nothing extra */
  if (window.IntersectionObserver) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('sud-pause', !e.isIntersecting); }); }, { rootMargin: '80px' });
    $$('.sud-hdiya, .sud-rowdiyas').forEach(function (d) { io.observe(d); });
  }
}
function buildCord() {
  cord = document.createElement('button');
  cord.type = 'button'; cord.className = 'sud-cord';
  cord.innerHTML = '<svg viewBox="-22 0 44 140" focusable="false"><line x1="0" y1="0" x2="0" y2="44" stroke="#8C7A55" stroke-width="1.3" stroke-linecap="round"/>' +
    '<g class="bd"><rect x="-2.2" y="-1" width="4.4" height="3" rx=".8" fill="#8A6A12"/><circle cx="0" cy="7.5" r="6" fill="#B8860B"/><circle cx="0" cy="7.5" r="6" fill="none" stroke="#7A5A0A" stroke-width=".8"/>' +
    '<circle cx="-2" cy="5.5" r="1.7" fill="#F6DE8C"/><path d="M0 13.5L0 21M-2.4 13.2L-3.6 20.4M2.4 13.2L3.6 20.4" stroke="#C79A1C" stroke-width="1.1" stroke-linecap="round"/></g></svg>';
  hdr.appendChild(cord);
  hint = document.createElement('span'); hint.className = 'sud-hint'; hint.setAttribute('aria-hidden', 'true'); hdr.appendChild(hint);
  line = $('line', cord); bead = $('.bd', cord);
  paintCord(); label();
  cord.addEventListener('pointerdown', function (e) {
    e.preventDefault(); C.lastPtr = performance.now(); C.drag = true; C.sx = e.clientX; C.sy = e.clientY; C.t0 = performance.now(); C.moved = false; C.clicked = false;
    try { cord.setPointerCapture(e.pointerId); } catch (err) {}
    hideHint(); runCord();
  });
  cord.addEventListener('pointermove', function (e) {
    if (!C.drag) return;
    var dy = e.clientY - C.sy, dx = e.clientX - C.sx;
    if (Math.abs(dy) > 5 || Math.abs(dx) > 5) C.moved = true;
    C.y = dy <= 0 ? 0 : dy < 40 ? dy : 40 + (dy - 40) * .35; if (C.y > 70) C.y = 70;
    C.x = Math.max(-16, Math.min(16, dx * .45)); C.vy = 0; C.vx = 0;
    if (!C.clicked && C.y > TRIP) { C.clicked = true; clickFeel(); }
    paintCord();
  });
  function release() {
    if (!C.drag) return;
    C.drag = false; C.lastPtr = performance.now();
    if (!C.moved && performance.now() - C.t0 < 450) { tapPull('tap'); return; }   /* a tap pulls it for you */
    if (C.clicked) toggleNight(undefined, 'drag');
    runCord();
  }
  cord.addEventListener('pointerup', release);
  cord.addEventListener('pointercancel', function () { C.drag = false; C.clicked = false; runCord(); });
  cord.addEventListener('click', function (e) {   /* keyboard (Enter / Space); a finger or mouse was already handled above */
    if (performance.now() - C.lastPtr < 800 || (e.pointerType && e.pointerType !== '')) return;
    tapPull('key');
  });
  addEventListener('scroll', function () {
    var y = scrollY, dd = y - C.lastScroll; C.lastScroll = y;
    if (C.drag || RM) return;
    C.vx += Math.max(-1.6, Math.min(1.6, dd * .03)); runCord();
  }, { passive: true });
  /* the "Pull for Diwali night" hint stays on every page, through scrolling, until the cord has been
     used once; after that it never shows again. The cord gives one small swing per visit to draw the eye. */
  if (ls('sud_cord_used') !== '1') {
    setTimeout(function () {
      if (ls('sud_cord_used') === '1') return;
      hint.classList.add('on');
      if (!RM && ss('sud_cord_hint') !== '1') { ss('sud_cord_hint', '1'); C.vx = 3.2; runCord(); }
    }, 1800);
  }
}
/* a tap switches the lights on the tap itself; the cord's pull animation just follows */
function tapPull(how) { C.pullUntil = performance.now() + 150; C.clicked = true; clickFeel(); toggleNight(undefined, how || 'tap'); runCord(); }
function hideHint() { if (hint) hint.classList.remove('on'); }
function label() {
  if (!cord) return;
  var on = isNight();
  cord.setAttribute('aria-pressed', on ? 'true' : 'false');
  cord.setAttribute('aria-label', on ? 'Diwali night is on. Pull to switch the lights back on' : 'Pull for Diwali night');
  hint.textContent = on ? 'Pull for the lights' : 'Pull for Diwali night';
}
function clickFeel() { try { if (navigator.vibrate) navigator.vibrate(8); } catch (e) {} }
function paintCord() {
  var by = REST + C.y;
  line.setAttribute('x2', C.x.toFixed(2)); line.setAttribute('y2', by.toFixed(2));
  bead.setAttribute('transform', 'translate(' + C.x.toFixed(2) + ' ' + by.toFixed(2) + ') rotate(' + (-C.x * 1.6).toFixed(1) + ')');
}
function runCord() { if (C.running) return; C.running = true; requestAnimationFrame(stepCord); }
function stepCord() {
  var pulling = C.pullUntil && performance.now() < C.pullUntil;
  if (pulling) {
    C.y += (34 - C.y) * .4; C.vy = 0;
  } else if (!C.drag) {
    C.pullUntil = 0;
    C.vy += -.2 * C.y; C.vy *= .8; C.y += C.vy; if (C.y < -6) { C.y = -6; C.vy *= -.3; }
    C.vx += -.07 * C.x; C.vx *= .93; C.x += C.vx;
  }
  paintCord();
  var still = !C.drag && !pulling && Math.abs(C.y) < .05 && Math.abs(C.vy) < .05 && Math.abs(C.x) < .05 && Math.abs(C.vx) < .05;
  if (still) { C.y = C.x = C.vy = C.vx = 0; paintCord(); C.running = false; C.clicked = false; return; }
  requestAnimationFrame(stepCord);
}
/* Every pull switches, at once. Each switch gets a number (nightSeq); anything still pending from
   an older switch (flicker steps, the barrage, the fade) sees a newer number and stops, so pulling
   again mid-flicker simply cuts across it. Pulls close together (within 1.5 s) skip the flicker and
   snap straight over behind a short fade. The fade runs on the GPU (Web Animations), so it stays
   smooth even while a slow phone repaints the page in its night colours. */
function later(s, f, ms) { setTimeout(function () { if (s === nightSeq) f(); }, ms); }
/* runs f once the frame showing the dark cover is on screen, so the slow part (the page taking its night
   colours) happens under the cover and the pull shows on the very next frame */
function afterPaint(s, f) { requestAnimationFrame(function () { requestAnimationFrame(function () { if (s === nightSeq) f(); }); }); }
function stopFade() { if (fade) { try { fade.cancel(); } catch (e) {} fade = null; } }
function cover() { stopFade(); curtain.style.willChange = 'opacity'; curtain.style.transition = 'none'; curtain.style.visibility = 'visible'; curtain.style.opacity = 1; }
function uncover(s, ms) {
  stopFade(); curtain.style.transition = 'none'; curtain.style.opacity = 0;
  if (curtain.animate) fade = curtain.animate([{ opacity: 1 }, { opacity: 0 }], { duration: ms, easing: 'ease' });
  later(s, function () { fade = null; curtain.style.visibility = 'hidden'; settled(s); }, ms + 40);
}
/* the curtain plays the flicker: [opacity, hold ms] steps */
function flicker(s, steps, done) {
  stopFade();
  curtain.style.willChange = 'opacity';   /* on its own GPU layer only while it plays */
  curtain.style.transition = 'none'; curtain.style.visibility = 'visible';
  (function next(i) {
    if (s !== nightSeq) return;   /* pulled again: this flicker stops where it is */
    if (i >= steps.length) { done(); return; }
    curtain.style.opacity = steps[i][0];
    setTimeout(function () { next(i + 1); }, steps[i][1]);
  })(0);
}
function setNightClass(on) { html.classList.toggle('night', on); ls('su_night', on ? '1' : '0'); label(); quiet(900); }
function settled(s) { if (s !== nightSeq) return; nightBusy = false; curtain.style.willChange = ''; }
/* night is on: the curtain lifts, string lights and diyas catch by themselves (staggered),
   a short barrage (at most once every 10 s), then fireflies for the rest of the night */
function nightIn(s, ms, fliesAfter) {
  twinkle(); guard(1600);
  uncover(s, ms);
  later(s, function () { barrage(3, 420, s); }, ms + 350);
  fireflies(fliesAfter);
}
function lightsOff(s, quick) {
  nightBusy = true;
  if (RM) { setNightClass(true); settled(s); guard(800); return; }
  if (quick) { cover(); afterPaint(s, function () { setNightClass(true); nightIn(s, 260, 1200); }); return; }
  /* the light fails: a few quick flickers, then dark */
  flicker(s, [[.82, 70], [.06, 60], [.9, 90], [.18, 45], [.95, 130], [.4, 40], [1, 170]], function () { setNightClass(true); nightIn(s, 550, 3200); });
}
function lightsOn(s, quick) {
  nightBusy = true;
  endFireflies(); clearInterval(twTimer); twTimer = null; guardStop();
  if (RM) { setNightClass(false); settled(s); return; }
  cover(); setNightClass(false);
  if (quick) { uncover(s, 140); return; }
  /* the light comes back like a tube light starting */
  flicker(s, [[.15, 60], [.85, 70], [.05, 45], [.7, 90], [.1, 60], [0, 0]], function () { curtain.style.visibility = 'hidden'; settled(s); });
}

/* =====================================================================
   4. NIGHT READABILITY GUARD
   Some sections paint their own light background (a white title band, a
   cream card) but take their text colour from the theme, which turns cream at
   night, so the text vanishes. After night comes on, this checks the page in
   small slices of idle time, measures each piece of text and each small icon
   against what is actually behind it, and fixes only clear failures:
     light text on a full-width light band -> the band goes dark   (sud-nbg)
     light text on a light card or button   -> the card keeps day text (sud-day)
     dark text on the dark page             -> the text turns cream  (sud-ntext)
   Text on a photo, video or gradient is left alone. Each piece is checked once
   (at most 2500 per page, in idle moments, about 6 ms at a time), and menus
   or drawers opened later are checked after a tap.
   The marks only act while it is night.
   ===================================================================== */
var GD = { done: typeof WeakSet === 'function' ? new WeakSet() : null, timer: 0, running: false, again: false, roots: [], count: 0, fixes: 0 };
var G_SKIP = '.sud-fx,.sud-curtain,.sud-defs,.sud-lights,.sud-cord,.sud-hint,.sud-hdiya,.sud-rowdiyas,.sud-bgarland,.su-cart,.su-bar,script,style,noscript,template,iframe,object,canvas,video';
var idle = window.requestIdleCallback ? function (f) { requestIdleCallback(f, { timeout: 1200 }); } : function (f) { setTimeout(function () { f({ timeRemaining: function () { return 6; } }); }, 50); };
function col(s) {
  s = String(s || ''); var m = s.match(/-?[\d.]+/g); if (!m || m.length < 3) return null;
  var k = s.indexOf('color(') === 0 ? 255 : 1;
  return [m[0] * k, m[1] * k, m[2] * k, m.length > 3 ? +m[3] : 1];
}
function lum(c) { var v = [c[0], c[1], c[2]].map(function (x) { x /= 255; return x <= .03928 ? x / 12.92 : Math.pow((x + .055) / 1.055, 2.4); }); return .2126 * v[0] + .7152 * v[1] + .0722 * v[2]; }
function ratio(a, b) { var x = lum(a), y = lum(b); return (Math.max(x, y) + .05) / (Math.min(x, y) + .05); }
function guard(delay) {
  if (!isNight() || !GD.done) return;
  clearTimeout(GD.timer);
  GD.timer = setTimeout(function () {
    if (!isNight()) return;
    if (GD.running) { GD.again = true; return; }
    GD.roots.push({ el: document.body, recheck: false }); GD.count = 0; GD.seen = 0; GD.running = true; idle(slice);
  }, delay || 600);
}
var gWalk = null, gRoot = null, gCache = null, gTodo = [];
/* lights back on: stop checking (a check made in day colours would be wrong for the night) */
function guardStop() { clearTimeout(GD.timer); GD.roots.length = 0; gWalk = null; gTodo = []; GD.running = false; GD.again = false; }
function gNext() {
  for (;;) {
    if (!gWalk) {
      gRoot = GD.roots.shift(); if (!gRoot) return null;
      gCache = new Map();
      gWalk = document.createTreeWalker(gRoot.el, 5, { acceptNode: function (n) {   /* 5 = elements and text */
        if (n.nodeType === 3) return /\S/.test(n.nodeValue) ? 1 : 3;
        if (n.matches(G_SKIP)) return 2;
        if (n.tagName === 'svg' || n.tagName === 'SVG') return n.getBoundingClientRect().width <= 48 ? 1 : 2;
        return /^(INPUT|SELECT|TEXTAREA)$/.test(n.tagName) ? 1 : 3;
      } });
    }
    var n = gWalk.nextNode();
    if (n) return n.nodeType === 3 ? n.parentElement : n;
    gWalk = null;
  }
}
function surface(el) {   /* the colour actually painted behind el, and the element painting it */
  var path = [], n = el, out = null;
  while (n && n.nodeType === 1) {
    if (gCache.has(n)) { out = gCache.get(n); break; }
    path.push(n);
    var cs = getComputedStyle(n);
    if (cs.backgroundImage && cs.backgroundImage !== 'none') { out = { media: true }; break; }
    var c = col(cs.backgroundColor);
    if (c && c[3] >= .5) { out = { c: c, el: n }; break; }
    if (n === document.body) { out = { c: [14, 10, 6, 1], el: n }; break; }
    n = n.parentElement;
  }
  out = out || { c: [14, 10, 6, 1], el: document.body };
  for (var i = 0; i < path.length; i++) gCache.set(path[i], out);
  return out;
}
function overMedia(el, top) {   /* is this text sitting on a picture? then leave it alone */
  var r = el.getBoundingClientRect(), n = el;
  while (n && n !== top && n.parentElement) {
    var p = n.parentElement;
    for (var k = p.firstElementChild; k; k = k.nextElementSibling) {
      if (k === n || !(/^(IMG|PICTURE|VIDEO|CANVAS)$/.test(k.tagName) || k.querySelector('img,picture,video'))) continue;
      var q = k.getBoundingClientRect();
      if (q.width && q.left < r.right && q.right > r.left && q.top < r.bottom && q.bottom > r.top) return true;
    }
    n = p;
  }
  return false;
}
function check(el) {
  if (!el || (!gRoot.recheck && GD.done.has(el))) return;
  if (!el.getClientRects().length) return;            /* not shown yet: checked when it opens */
  var cs = getComputedStyle(el);
  if (cs.visibility === 'hidden' || +cs.opacity < .1) return;
  GD.done.add(el); GD.count++;
  var svg = el.tagName === 'svg' || el.tagName === 'SVG';
  var fg = col(svg && cs.fill && cs.fill.indexOf('url') < 0 && cs.fill !== 'none' ? cs.fill : cs.color);
  if (!fg || fg[3] < .35) return;
  var bg = surface(el);
  if (bg.media || ratio(fg, bg.c) >= 2.8) return;
  var Lb = lum(bg.c), Lf = lum(fg), p = bg.el;
  if (Lb > .4 && Lf > .4) {
    if (p === document.body || p.classList.contains('sud-nbg') || p.classList.contains('sud-day')) return;
    gTodo.push([p, p.offsetWidth >= innerWidth * .92 ? 'sud-nbg' : 'sud-day']);
  } else if (Lb < .2 && Lf < .2 && !overMedia(el, p)) gTodo.push([el, 'sud-ntext']);
}
function slice(dl) {
  if (!isNight()) { guardStop(); return; }
  var t0 = performance.now(), el;
  while ((el = gNext())) {
    if (GD.count > 2500 || ++GD.seen > 15000) { GD.roots.length = 0; gWalk = null; break; }   /* hard ceiling on work per run */
    try { check(el); } catch (e) {}
    if (performance.now() - t0 > 6 || (dl && dl.timeRemaining && dl.timeRemaining() < 1)) break;
  }
  if (gTodo.length) {   /* apply this slice's fixes together, then re-check inside what changed */
    gTodo.forEach(function (f) { if (!f[0].classList.contains(f[1])) { f[0].classList.add(f[1]); GD.fixes++; if (f[1] !== 'sud-ntext') GD.roots.push({ el: f[0], recheck: true }); } });
    gTodo = [];
  }
  if (el || gWalk || GD.roots.length) { idle(slice); return; }
  GD.running = false;
  if (GD.again) { GD.again = false; guard(300); }
}
/* menus, drawers and "load more" open later: check them a moment after a tap */
document.addEventListener('click', function () { if (isNight()) guard(700); }, { passive: true, capture: true });
/* =====================================================================
   5. TRACKING THE CORD
   Each pull sends su_diwali_night_on (the lights go off, Diwali night) or
   su_diwali_night_off (the lights come back on), with:
     how   tap, drag or key (Enter / Space)
     pull  the number of this pull in the visit (1 = first)
     first yes when this phone has never pulled it before, else no
     page  the page type (index, collection, product, ...)
   to Microsoft Clarity (a custom event, the session tagged su_diwali_cord =
   pulled and kept), the dataLayer, Shopify customer events, and GA4 (gtag) /
   Meta (fbq) when they are on the page. At most 10 pulls per page are sent, so
   someone playing with the cord does not flood the reports (the cord itself
   still answers every pull).
   Orders: a browser that has pulled the cord remembers it for 30 days, and
   every cart it builds carries the attribute "Diwali night: pulled" (shown on
   the order under Additional details). Like the wish orders tracker, it is put
   back on page load, again 4 s later and when the page is left, in case the
   checkout or a chat app rebuilt the cart. Only browsers that pulled it check.
   ===================================================================== */
var TRK = { sent: 0, tagged: false }, PULLED = 'sud_night_pulled';
function tagCart() {
  var at = +ls(PULLED) || 0;
  if (!at || Date.now() - at > 30 * 864e5 || !window.fetch) return;
  fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
    if (c && c.attributes && c.attributes['Diwali night'] === 'pulled') return;
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: { 'Diwali night': 'pulled' } }), keepalive: true });
  }).catch(function () {});
}
function trackPull(on, how, first) {
  var pull = (+ss('sud_pulls') || 0) + 1; ss('sud_pulls', String(pull));
  if (!(+ls(PULLED))) { ls(PULLED, String(Date.now())); try { tagCart(); } catch (e) {} }
  if (++TRK.sent > 10) return;
  var ev = on ? 'su_diwali_night_on' : 'su_diwali_night_off', data = { how: how, pull: pull, first: first ? 'yes' : 'no', page: TPL || 'other' };
  try { var dl = { event: ev }; for (var k in data) dl[k] = data[k]; (window.dataLayer = window.dataLayer || []).push(dl); } catch (e) {}
  try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(ev, data); } catch (e) {}
  try {
    if (typeof window.clarity === 'function') {
      clarity('event', ev);
      if (!TRK.tagged) { TRK.tagged = true; clarity('set', 'su_diwali_cord', 'pulled'); clarity('upgrade', 'su_diwali_cord'); }
    }
  } catch (e) {}
  try { if (typeof window.gtag === 'function') gtag('event', ev, data); } catch (e) {}
  try { if (typeof window.fbq === 'function') fbq('trackCustom', ev, data); } catch (e) {}
}
/* every pull switches the lights at once; only the fireworks a pull sets off are limited.
   how is given only for a real pull of the cord, so only those are tracked */
function toggleNight(force, how) {
  var on = force === undefined ? !wantNight : force;
  if (on === wantNight) return;
  wantNight = on;
  var first = ls('sud_cord_used') !== '1';
  if (how) { try { trackPull(on, how, first); } catch (e) {} }
  if (ls('sud_cord_used') !== '1') { ls('sud_cord_used', '1'); hideHint(); }   /* used once: the hint is done for good */
  var now = performance.now(), quick = now - lastFlip < 1500, s = ++nightSeq;
  lastFlip = now;
  if (bead) { var b = bead.getBoundingClientRect(); crackleAt(b.left + b.width / 2, b.top + b.height / 2, 6, 8); }
  if (on) lightsOff(s, quick); else lightsOn(s, quick);
}

/* =====================================================================
   schedule: one show every 2.5 to 3.5 s at random (home and collection
   pages), including while the cart drawer is open. Paused only while the
   cord is being pulled, the spark is flying into the cart, the lights are
   flickering, or the theme's menu or search drawer is open.
   ===================================================================== */
function busy() {
  return C.drag || flights.length > 0 || nightBusy || html.classList.contains('prevent-scroll') || !!$('.m-menu-drawer.open');
}
var timer = null, scrolling = 0, stopped = false, waited = 0;
addEventListener('scroll', function () { scrolling = performance.now(); }, { passive: true });
/* during a scroll a show waits a moment for the page to settle, but never more than about a second */
function tryShow() {
  if (stopped) return;
  if (performance.now() - scrolling < 300 && waited < 3) { waited++; timer = setTimeout(tryShow, 300); return; }
  waited = 0; show(); schedule();
}
function schedule(first) {
  clearTimeout(timer);
  if (!BROWSE || stopped || reduce || document.hidden) return;
  timer = setTimeout(tryShow, first ? 1200 : rand(2500, 3500));
}
document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else schedule(); });
var rz;
addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { size(); lightSets.forEach(layoutLights); }, 120); });

size();
/* the watchdog does not judge the first moments of a page: the page itself is still loading then, and that jank is not the fireworks' */
quiet(document.readyState === 'complete' ? 2500 : 6000);
if (document.readyState !== 'complete') addEventListener('load', function () { quiet(2500); });
curtain = document.createElement('div'); curtain.className = 'sud-curtain'; curtain.setAttribute('aria-hidden', 'true');
document.body.appendChild(curtain);
placeDiyas();
if (hdr) { buildLights(hdr); buildCord(); }
if (isNight()) {
  twinkle(); fireflies(1500);
  if (document.readyState === 'complete') guard(1200); else addEventListener('load', function () { guard(1200); });
}
schedule(true);
if (+ls(PULLED)) {
  var tagStart = function () { try { tagCart(); } catch (e) {} setTimeout(function () { try { tagCart(); } catch (e) {} }, 4000); };
  if (document.readyState === 'complete') tagStart(); else addEventListener('load', tagStart);
}
document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') { try { tagCart(); } catch (e) {} } });
window.__sud = {
  toggleNight: toggleNight, stop: function () { stopped = true; clearTimeout(timer); timer = null; },
  barrage: barrage, show: show, isNight: isNight, browse: function () { return BROWSE; },
  parts: function () { return parts.length; }, rockets: function () { return rockets.length; }, shells: function () { return shells; }, flights: function () { return flights.length; },
  flies: function () { return flies.length; }, nightBusy: function () { return nightBusy; },
  dpr: function () { return DPR; }, Q: function () { return Q; }, cap: function () { return CAP; }, C: C, hooked: function () { return !!inst; },
  tier: function () { return TIER; }, smokes: function () { return smokes.length; }, flashes: function () { return flashes.length; },
  guard: function () { return { running: GD.running, checked: GD.count, fixes: GD.fixes }; }, tracked: function () { return TRK.sent; },
  flames: function () { return { head: !!(headFl && headFl.classList.contains('on')), garland: !!(barGarland && barGarland.isConnected) }; }
};
})();
